import type { ComponentProps } from 'react';
import { useMemo } from 'react';
import type { PeticePeticeDto } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import { EPetitionStatus } from '@gov-nx/module/page';
import { Chip } from '@gov-nx/ui/web';

type EPetitionChipsProps = {
	code: string;
	petition: PeticePeticeDto;
	size?: ComponentProps<typeof Chip>['size'];
};

export const EPetitionChips = ({
	code,
	petition,
	size = 'xs',
}: EPetitionChipsProps) => {
	const { t } = useLocale(code);

	const states = useMemo(
		() => ({
			[EPetitionStatus.rozpracovana]: t('odznak.rozpracovana'),
			[EPetitionStatus.zverejnena]: t('odznak.zverejnena'),
			[EPetitionStatus.uzavrena]: t('odznak.ukoncena'),
			[EPetitionStatus.podana]: t('odznak.podana'),
			[EPetitionStatus.zamitnuta]: t('odznak.zamitnuta'),
			[EPetitionStatus.vytvorena]: t('odznak.vytvorena'),
		}),
		[t]
	);

	return (
		<ul className="gov-list--plain mt-0! p-0! flex gap-1 overflow-x-auto whitespace-nowrap [ xl:overflow-x-visible ]">
			<Chip
				color="neutral"
				type="outlined"
				size={size}>
				<span>{states[petition.stav as EPetitionStatus]}</span>
			</Chip>
			{petition.mnouZalozene && (
				<li>
					<Chip
						color="primary"
						type="outlined"
						size={size}>
						<span>{t('odznak.moje-petice')}</span>
					</Chip>
				</li>
			)}
			{petition.mnouPodepsane && (
				<li>
					<Chip
						color="success"
						type="outlined"
						size={size}>
						<span>{t('odznak.podepsana')}</span>
					</Chip>
				</li>
			)}
		</ul>
	);
};
